import React from 'react';
import './ThreeColumn.less';
import { SecondKillComp } from '../../activityComp';
import { dateformat } from '../../../utils';
import autobind from 'autobind-decorator';

export interface ThreeColumnPropType {
    prefixCls?: string;
    data?: any;
    toAppDetail?: (data?: any) => void; // 跳转商品详情
}

export interface ThreeColumnState {

}

/**
 * 三列列表条目组件
 * @class ThreeColumn
 * @extends {React.Component<ThreeColumnPropType, ThreeColumnState>}
 */
class ThreeColumn extends React.Component<ThreeColumnPropType, ThreeColumnState> {
    static defaultProps = {
        prefixCls: 'three-column'
    };

    dataType: any = {
        '11': '开始秒杀',
        '12': '开始抢购',
        '21': '结束秒杀',
        '22': '结束抢购'
    };

    @autobind
    private _showText(data: any): any {
        const typeStr: string = '' + `${data.promotStatus}${data.type}`;
        return this.dataType[typeStr];
    }

    @autobind
    private _showTime(data: any): any {
        const typeStr: string = '' + `${data.promotStatus}${data.type}`;
        if (typeStr === '11' || typeStr === '12') {
            return data.startTime / 1000;
        } else if (typeStr === '21' || typeStr === '22') {
            return data.endTime / 1000;
        }
    }

    render() {
        const {prefixCls, data = {}, toAppDetail} = this.props;
        const defaultStyles = {
            ellipsis: {
                WebkitBoxOrient: 'vertical'
            }
        };
        return (
            <div className={`${prefixCls}`} onClick={toAppDetail}>
                {
                    data.promotStatus !== 0 && data.promotStatus !== null && data.type !== 0 && (
                        <div className={`${prefixCls}-activeBox`}>
                            <SecondKillComp
                                size='xs'
                                text={this._showText(data)}
                                date={dateformat(this._showTime(data), 'mm月dd日 HH:MM')}
                            />
                        </div>
                    )
                }
                <div className={`${prefixCls}-img-box`}>
                    <img src={data.mastermap}/>
                    {data.status == -1 && <div className={`${prefixCls}-lootAll`}>抢光了～</div>}
                </div>
                <div className={`${prefixCls}-content`}>
                    <div className={`${prefixCls}-title`} style={defaultStyles.ellipsis}>
                        {data.brandsName}·{data.productName}
                    </div>
                    <div className={`${prefixCls}-present-price`}>
                        <span className={`${prefixCls}-yuan`}>￥</span>
                        <span className={`${prefixCls}-price`}>
                            {data.price}
                        </span>
                        <div className={`${prefixCls}-delimit`}>
                            ￥{data.marketPrice}
                            <i/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ThreeColumn;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/specialItem/threeColumn/ThreeColumn.tsx